import { makeValidated } from '../utils';
import interpolate from '../interpolate';
import schema from '../../schema/init-layout.schema.json';

const mapInitLayout = action => ({
  type: 'LAYOUT_SETUP',
  payload: {
    value: action.data,
  },
});

const initLayout = (context, event, meta) => {
  const validated = makeValidated(schema);
  return mapInitLayout(validated(interpolate(meta.action, event, context)));
};

export default initLayout;
